import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { SyncMarketingTemplatesResponse } from "../../marketing.types";

export const requestSyncMarketingTemplates =
  async (): Promise<SyncMarketingTemplatesResponse> => {
    return await instance.post(ApiRoutesMarketing.TemplatesSync);
  };
